import { useEffect, useState } from "react";
import { Collapse, List, Typography, Spin } from "antd";
import anketaService from "../../services/anketa.service";
import "./AnalizaInstanciPopunjavanja.css";

const { Panel } = Collapse;
const { Text } = Typography;

const AnalizaInstanciPopunjavanja = ({ anketaId }) => {
  const [instance, setInstance] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInstance = async () => {
      try {
        const res = await anketaService.getInstances(anketaId);
        setInstance(res.data);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchInstance();
  }, [anketaId]);

  if (loading) return <Spin tip="Učitavanje..." />;

  const grupisaniOdgovori = Object.fromEntries(
    Object.entries(instance).map(([serijskaOznaka, odgovori]) => {
      const poPitanju = {};
      odgovori.forEach((o) => {
        if (!poPitanju[o.tekstPitanja]) {
          poPitanju[o.tekstPitanja] = [];
        }
        poPitanju[o.tekstPitanja].push(o.odgovorTekst);
      });
      return [serijskaOznaka, poPitanju];
    })
  );

  return (
    <div className="container">
      <div className="anketa-card analiza-instanci">
        <Collapse accordion style={{ width: "100%" }}>
          {Object.entries(grupisaniOdgovori).map(
            ([serijskaOznaka, pitanja], index) => (
              <Panel header={`Instanca: ${index + 1}`} key={serijskaOznaka}>
                <List
                  dataSource={Object.entries(pitanja)}
                  renderItem={([tekstPitanja, odgovori]) => (
                    <List.Item>
                      <Text strong>Pitanje:</Text> {tekstPitanja} <br />
                      <Text strong>Odgovor:</Text> {odgovori.join(", ")}
                    </List.Item>
                  )}
                />
              </Panel>
            )
          )}
        </Collapse>
      </div>
    </div>
  );
};

export default AnalizaInstanciPopunjavanja;


